import {useState} from "react";
import {RIODateTime} from "../../lib/RIODateTime.ts";
import {DatePicker, DatePickerType} from "../../components/Form/DatePicker.tsx";
import {DataLoadingError} from "../../components/DataLoadingError.tsx";
import {DataGrid} from "../../components/DataGrid";
import {Button, ButtonToolbar} from "../../components/Button.tsx";
import {exportToCSV} from "../../components/DataGrid/exportToCSV.ts";
import {DataGridToolbar} from "../../components/DataGrid/DataGridToolbar.tsx";
import {useFindAllDriversQuery} from "../../api/driver.slice.ts";
import {Select} from "@rio-cloud/rio-uikit";
import {toApiDate, useFilteredByRioDriverIdAndTimeSpanQuery} from "../../api/shift.slice.ts";
import humanizeDuration from "humanize-duration";

function download(filename: string, text: string) {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

export const ShiftList = () => {

    const [start, setStart] = useState<RIODateTime>(RIODateTime.Now());
    const [end, setEnd] = useState<RIODateTime>(RIODateTime.Now().plus({days: 7}));
    const [selectedDriverId, setSelectedDriverId] = useState<string | undefined>();



    const {data: drivers, isLoading: driversLoading} = useFindAllDriversQuery()
    const {data, isLoading, error} = useFilteredByRioDriverIdAndTimeSpanQuery({start: toApiDate( start), end: toApiDate(end), driverId: selectedDriverId || ""});
    // const {data: surchargeGroups, isLoading: surchargeGroupsIsLoading} = useGetSurchargeGroupsQuery()


    const surchargeGroups: string[] = []

    // useEffect(() => {
        data?.forEach((shift) => {
            shift.applicableSurcharges.forEach( s => {
                if(surchargeGroups.indexOf(s.name) === -1){
                    surchargeGroups.push(s.name)
                }
            })
        })
    //
    // },[data])


    console.log(surchargeGroups)



    const columns = [
        {
            key: "driverName",
            label: "DriverName",
            synthetic: true,
            render: (row: any) => <>
                {row.driver?.firstName} {row.driver?.lastName}
            </>,
        },
        {
            key: "bookingDate",
            label: "BookingDate",
            synthetic: true,
            render: (row: any) => RIODateTime.FromISO(row.bookingDate).toPredefinedFormat(RIODateTime.PREDEFINED_FORMATS.GERMAN_DATE)
        },
        {
            key: "start",
            label: "Start",
            synthetic: true,
            render: (row: any) => RIODateTime.FromISO(row.start).toPredefinedFormat(RIODateTime.PREDEFINED_FORMATS.GERMAN_DATE_TIME)
        },
        {
            key: "end",
            label: "End",
            synthetic: true,
            render: (row: any) => RIODateTime.FromISO(row.start).toPredefinedFormat(RIODateTime.PREDEFINED_FORMATS.GERMAN_DATE_TIME)
        },
        {key: "totalDuration", label: "Duration", convert: (v:any) => humanizeDuration(v * 1000)},
        {key: "drivingDuration", label: "DrivingDuration",  convert: (v:any) => humanizeDuration(v* 1000)},
        {key: "workingDuration", label: "WorkingDuration",  convert: (v:any) => humanizeDuration(v* 1000)},
        {key: "bankHolidayDuration", label: "BankHolidayDuration",  convert: (v:any) => humanizeDuration(v* 1000)},
        {key: "shiftType", label: "ShiftType"},
        ...(surchargeGroups).map(group => ({
            key: group,
            label: group,
            synthetic: true,
            render: (row: any) => {
                const duration  =row.applicableSurcharges.filter((x: any) => x.name === group).reduce((sum: any, item: any) => sum + item.duration, 0)

                return <>{ humanizeDuration(duration * 1000)}</>

            },
        })),
    ]


    return <>
        <div className='display-flex gap-10 max-width-400 margin-bottom-10'>
            <div className='flex-1-1-0'>
                <label htmlFor='driver'>Driver:</label>
                <Select
                    label={"Driver"}
                    onChange={(value) => setSelectedDriverId(value?.id)}
                    options={drivers?.map(driver => ({
                        id: driver.rioId,
                        label: `${driver.firstName} ${driver.lastName}`
                    })) || []} useFilter/>
            </div>

        </div>
        <div className='display-flex gap-10 max-width-400 margin-bottom-10'>
            <div className='flex-1-1-0'>
                <label htmlFor='from'>From:</label>
                <DatePicker
                    value={start.toJSDate()}
                    type={DatePickerType.DATE}
                    onChange={(result: RIODateTime) => setStart(result)}
                />
            </div>
            <div className='flex-1-1-0'>
                <label htmlFor='to'>To:</label>
                <DatePicker
                    value={end.toJSDate()}
                    type={DatePickerType.DATE}
                    onChange={(result: RIODateTime) => setEnd(result)}
                />
            </div>


        </div>

        <DataLoadingError isLoading={isLoading} error={error}>
            <DataGridToolbar>
                <ButtonToolbar>
                    <div></div>
                </ButtonToolbar>
                <ButtonToolbar>
                    <Button isDisabled={true} onClick={() => download("file.csv", exportToCSV(data || [], columns))}
                            disabled={driversLoading} size={"xs"}
                            glyph={"save"}>
                        Download CSV
                    </Button>
                </ButtonToolbar>
            </DataGridToolbar>
            <DataGrid columns={columns} data={data || []} onRowDoubleClick={(row) => {
                window.open(`/worktimeexpense/#/shift/${row.id}`)
            }}/>
        </DataLoadingError>

    </>
}